import { render, staticRenderFns } from "./workerSubsidy.vue?vue&type=template&id=6395eab1&"
import script from "./workerSubsidy.vue?vue&type=script&lang=js&"
export * from "./workerSubsidy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports